import Section4img1 from "../assets/images/Section4img1.png";
import Section4img2 from "../assets/images/Section4img2.png";
import Section4img3 from "../assets/images/Section4img3.png";
import Section4img4 from "../assets/images/Section4img4.png";
import Section4img5 from "../assets/images/Section4img5.png";
import Section4img6 from "../assets/images/Section4img6.png";
import Section4img7 from "../assets/images/Section4img7.png";

import Driver1 from "../assets/images/Driver1.png"
import Driver2 from "../assets/images/Driver2.png"
import Driver3 from "../assets/images/Driver3.png"
import Driver4 from "../assets/images/Driver4.png"
import Driver5 from "../assets/images/Driver5.png"
import Driver6 from "../assets/images/Driver6.png"

import Host1 from "../assets/images/Host1.png"
import Host2 from "../assets/images/Host2.png"
import Host3 from "../assets/images/Host3.png"
import Host4 from "../assets/images/Host4.png"
import Host5 from "../assets/images/Host5.png"
import Host6 from "../assets/images/Host6.png"
import Host7 from "../assets/images/Host7.png"




export const Drivers = [
  {
    id: "1",
    number: "1",
    image: Driver1,
    detail1: "Sign Up",
    detail2: "Create an account and select a subscription plan that fits your driving needs (e.g., Bronze, Silver, Gold).",
  },
  {
    id: "2",
    number: "2",
    image: Driver2,
    detail1: "Find Chargers",
    detail2: "Use the SplitEV app to locate nearby private EV chargers.",
  },
  {
    id: "3",
    number: "3",
    image: Driver3,
    detail1: "Reserve a Spot",
    detail2: "Filter chargers by type, availability, or proximity, and reserve a charging station.",
  },
  {
    id: "4",
    number: "4",
    image: Driver4,
    detail1: "Navigate with Ease",
    detail2: "Get directions to the charger through the app’s built-in navigation feature.",
  },
  {
    id: "5",
    number: "5",
    image: Driver5,
    detail1: "Start Charging",
    detail2: "Use the app to begin charging your vehicle seamlessly.",
  },
  {
    id: "6",
    number: "6",
    image: Driver6,
    detail1: "24/7 Support",
    detail2: "Access customer support through the app for any assistance or troubleshooting.",
  },
];



export const Hosts = [
  {
    id: "5",
    number: "5",
    image: Host1,
    detail1: "Register as a Host",
    detail2: "Sign up and list your EV charger through the SplitEV platform.",
  },
  
    {
      id: "6",
      number: "6",
      image: Host2,
      detail1: "Set Preferences",
      detail2: "Customize availability and other settings for your charger.",
    },

    {
      id: "7",
      number: "7",
      image: Host3,
      detail1: "Attract Drivers",
      detail2: "EV drivers in your area can easily find and reserve your charger.",
    },
    {
      id: "8",
      number: "8",
      image: Host4,
      detail1: "Manage Reservations",
      detail2: "Approve reservations and monitor charger usage through the host dashboard.",
    },
    {
      id: "9",
      number: "9",
      image: Host5,
      detail1: "Earn Income",
      detail2: "Get paid for every charging session.",
    },
    {
      id: "10",
      number: "10",
      image: Host6,
      detail1: "Track Performance",
      detail2: "Access insights and analytics on charger usage and earnings.",
    },
    {
      id: "11",
      number: "11",
      image: Host7,
      detail1: "Support Sustainable Transport",
      detail2: "Contribute to the EV community by helping reduce emissions and supporting sustainable transportation.",
    },





  ];